var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 1.5H12C11.6023 1.5004 11.221 1.65856 10.9398 1.93978C10.6586 2.221 10.5004 2.6023 10.5 3V10.5H3C2.6023 10.5004 2.221 10.6586 1.93978 10.9398C1.65856 11.221 1.5004 11.6023 1.5 12V22.5H22.5V3C22.4995 2.60232 22.3414 2.22105 22.0602 1.93984C21.7789 1.65864 21.3977 1.50046 21 1.5ZM6.75 21V15.75H9.75V21H6.75ZM21 21H11.25V15C11.25 14.8011 11.171 14.6103 11.0303 14.4697C10.8897 14.329 10.6989 14.25 10.5 14.25H6C5.80109 14.25 5.61032 14.329 5.46967 14.4697C5.32902 14.6103 5.25 14.8011 5.25 15V21H3V12H12V3H21V21ZM15 6H13.5V7.5H15V6ZM18 6H19.5V7.5H18V6ZM15 10.5H13.5V12H15V10.5ZM18 10.5H19.5V12H18V10.5ZM15 14.9997H13.5V16.4997H15V14.9997ZM18 14.9997H19.5V16.4997H18V14.9997Z",
    fill: "#050A25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.1f319335d21d2f42d5b6620237b5af24.svg";
export { ForwardRef as ReactComponent };